<template>
<div class="panal mt-20">
<div class="panal-header">Payment</div>

  <div class="container">
    <div class="row">
      <div class="col-md-12" >
        <div class="alert alert-primary mt-5" role="alert">
          Admission Fees for the Academic Year 2024-2025 for Egyptians 1000 LE
          <span class="float-right">

            <div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio3" value="option3" disabled>
  <label class="form-check-label" for="inlineRadio1">Paid</label>
</div>
<div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio4" value="option4" checked>
  <label class="form-check-label" for="inlineRadio2">UnPaid</label>
</div>

          </span>
        
          <hr/>
        
  Admission DownPayment Fees for The Academic Year 2024-2025 for Egyptians 20000 LE
          <span class="float-right">

<div class="form-check form-check-inline">
<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" disabled>
<label class="form-check-label" for="inlineRadio1">Paid</label>
</div>
<div class="form-check form-check-inline">
<input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" checked>
<label class="form-check-label" for="inlineRadio2">UnPaid</label>
</div>


</span>

          <div class="clearfix"></div>
</div>

        <div class="card mt-5">
  <h5 class="card-header">Payment OffLine</h5>
  <div class="card-body">
    <p>You Can DownLoad Payment Order</p>
    <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
    <a href="#" class="btn btn-primary" @click.prevent="DownloadPaymentPdf()">DownLoad</a>
  </div>
</div>

<div class="card mt-5">
  <h5 class="card-header">Payment OnLine</h5>
  <div class="card-body">
    <P>You Can Payment By  </p>

      <div class="form-check form-check-inline">
  <input class="form-check-input mr-2" type="radio" id="inlineCheckbox1" value="option1" Name="One">
  <label class="form-check-label mr-2" for="inlineCheckbox1"><img src="../../assets/visa.png" alt="visa" width="60px"></label>

  <input class="form-check-input mr-2" type="radio" id="inlineCheckbox2" value="option2" Name="One">
  <label class="form-check-label mr-2" for="inlineCheckbox2"><img src="../../assets/mastercard.png" alt="mastercard" width="60px"></label>

  <input class="form-check-input" type="radio" id="inlineCheckbox3" value="option3" Name="One">
  <label class="form-check-label" for="inlineCheckbox3"><img src="../../assets/PayPal.png" alt="PayPal" width="80px"></label>
</div>

<h5 class="card-title mt-3">Fill Form below</h5>
<div class="col-md-12">
<form class="row">
 <div class="col-md-6"> <input class="form-control su-border" type="text" placeholder="Card Number" aria-label="Card Number"></div>
 <div class="col-md-6"><input class="form-control su-border" type="Date" placeholder="Expiry Date" aria-label="Expiry Date"></div>
  <div class="col-md-6"><input class="form-control mt-3 su-border" type="text" placeholder="Name On Card" aria-label="Name On Card"></div>
    <div class="col-md-3"> <input class="form-control mt-3 su-border" type="text" placeholder="CVV" aria-label="CVV"></div>
</form></div>
    <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->

    <div class="alert alert-warning mt-5" role="alert"> Service not available now</div>
    <div class="text-center" disabled>
      
      <button type="button" class="btn btn-primary mt-3" disabled>Confirm Paymen</button>
      <!-- <a href="#" class="btn btn-primary mt-3">Confirm Payment</a> -->
    </div>
  </div>
</div>



      
        
    
      

      </div>

    </div>
  </div>
</div>




</template>

<script>
import ApplicantService from '../../services/Applicant/Applicant.service';
//   import ApplicantService from '../../services/Applicant/Applicant.service'
// import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
// import { TermsAccept } from '../../models/Applicant';
  export default {

    data() {
      return {
        downPDF: '',
      
      }
    },
    mounted() {

      
    },
    methods: {

      DownloadPaymentPdf(){
        ApplicantService.GetDownloadPaymentPdf(this.currenUser.UserIDSerial).then(Response => {
          // location.href=Response.data;
        this.downPDF = Response.data

        
        // var fileName = 'myFirstPDF.pdf' //if you have the fileName header available
        //   /*  window.location = fileName;*/
        //     var link = document.createElement('a');
        //     link.href = URL.createObjectURL(new Blob([Response.data]));
        //     link.download = fileName;
        //     link.target = "_blank"
        //     link.click();
            

        const contentDispositionHeader = Response.headers['content-disposition'];
        const fileName = contentDispositionHeader
          ? contentDispositionHeader.split('filename=')[1].trim()
          : 'document.pdf'; // Default file name if the server doesn't provide one

        const url = window.URL.createObjectURL(new Blob([Response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        link.setAttribute('target', "_blank");

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      }, error => {

        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
          if(error.response.status == 404) this.message =''
      });
      }
  
    },
    computed: {
      currenUser() {
        return this.$store.state.auth.user
      }
    },
  }
</script>

<style scoped>
  table tr th {
    background-color: #4caf5000 !important;
    color: #333;
  }

  .panal{
  background:#fff;
  border-radius:10px;
color:#333;
padding:0px 0px 50px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}
.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}
</style>